module.exports = __webpack_public_path__ + "img/chevrons-right.e66fa831.svg";